var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "24px",
    viewBox: "0 0 16 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0ABD8716-2EBC-4240-BA6B-02E65FE1B8C5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-676.000000, -4161.000000)",
    fill: "#FFFFFF",
    stroke: "#464646"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ImajBoyutu-Dikd\\xF6rtgen-Copy-2",
    transform: "translate(684.000000, 4173.333333) rotate(90.000000) translate(-684.000000, -4173.333333) ",
    x: 673,
    y: 4166,
    width: 22,
    height: 14.6666667,
    rx: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFull);
export default __webpack_public_path__ + "static/media/Full.d14f13588134ba74954997de7a2336b1.svg";
export { ForwardRef as ReactComponent };